'use client';

import type { ComponentProps } from 'react';
import type { LotteryName } from '../../lottery-purchases/types';
import { ResultsCarousel } from './ResultsCarousel/ResultsCarousel';

type DiscoverPageResultsCarouselProps = Omit<ComponentProps<typeof ResultsCarousel>, 'lotteries' | 'namespace'>;

const lotteries: LotteryName[] = [
    'powerBall',
    'megaMillions',
    'irishLotto',
    'euroJackpot',
    'euroMillionsPlus',
    'polishMiniLotto',
    'euroDreams',
    'superEnalotto',
    'lotto5',
    'euroMillionsGo',
  ],
  NAMESPACE = 'lotteries.discover_page.results_carousel';

/**
 * Carousel of results section for lotteries discover page.
 * Based on the list of results provided renders ResultsCarousel component with ResultsSection inside, action button and section title.
 * @returns ResultsCarousel component.
 */
function DiscoverPageResultsCarousel(props: DiscoverPageResultsCarouselProps) {
  return <ResultsCarousel lotteries={lotteries} namespace={NAMESPACE} {...props} />;
}

export { DiscoverPageResultsCarousel };
